import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, CheckCircle2 } from "lucide-react";
import { SitePage, PageHead } from "./SiteChrome";
import { PLATFORMS } from "./siteData";

export default function PlatformDetailPage() {
  const { slug } = useParams();
  const p = PLATFORMS.find((x) => x.slug === slug);
  if (!p) return <Navigate to="/platforms" replace />;

  return (
    <SitePage testId={`platform-detail-${p.slug}`}>
      <Link to="/platforms" className="sp-back" data-testid="platform-back-link">
        <ArrowLeft size={13} /> All platforms
      </Link>
      <div className={`sp-detail-hero p-${p.variant}`}>
        <div className="pcard-icon-wrap"><p.icon size={26} /></div>
        <div>
          <PageHead label={p.audience} title={<>{p.name}. <span className="grad-text">{p.tagline}</span></>} lede={p.summary} />
          <div className="sp-detail-ctas">
            <a href={p.href} target="_blank" rel="noopener noreferrer" className="btn-primary sp-btn" data-testid="platform-visit-btn">
              Visit {p.name} <ArrowRight size={15} />
            </a>
            <Link to="/contact?type=beta" className="btn-glass sp-btn" data-testid="platform-beta-btn">
              Get Beta Access
            </Link>
          </div>
        </div>
      </div>

      <div className="sp-section-label">
        <div className="section-label"><span className="label-line" /> Capabilities</div>
      </div>
      <div className="trust-grid sp-feature-grid">
        {p.features.map((f) => (
          <div className="trust-card" key={f.t}>
            <span className="trust-card-icon"><CheckCircle2 size={18} /></span>
            <div>
              <div className="trust-card-title">{f.t}</div>
              <div className="trust-card-sub">{f.d}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="sp-cta-strip">
        <p>{p.name} is part of the CamelionAI ecosystem — intelligence flows both ways.</p>
        <Link to="/trust" className="btn-glass sp-btn">How our technology works</Link>
      </div>
    </SitePage>
  );
}
